import React from 'react';

import TableAntd from '../../../Components/TableAntd/TableAntd';

export default function ReasonNoBillingList() {
  const columns = (getColumnSearchProps) => {
    const columns = [
      {
        dataIndex: 'name',
        title: 'Nome',
        ...getColumnSearchProps('name', 'Nome'),
        sorter: (a, b) => a.name?.localeCompare(b.name),
        sortDirections: ['descend', 'ascend'],
      },
    ];
    return columns;
  };

  return (
    <TableAntd
      columnsTable={(getColumnSearchProps) => columns(getColumnSearchProps)}
      routePermissions="ReasonNoBilling"
      toggleStatusRoute="DenyTaskReason"
      requestName="DenyTaskReason?filters[0].Field=Type&filters[0].Condition=IN&filters[0].Value=NoBilling"
      route="/MotivoNaoFaturamento"
      cdPage="id"
      btnNew={true}
    />
  );
}
